'use client'

import type { ReactNode } from 'react'

import './Benefits.css'

import type { BenefitItemProps } from './BenefitItem'

import { useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import styled from 'styled-components'

import qmark from '@/assets/images/microsite/benefits/question_mark.svg'
import terms from '@/assets/images/microsite/benefits/terms.svg'
import Link from '@/components/Link'
import useStore from '@/stores/Store'
import BenefitItem from './BenefitItem'

interface BenefitsProps {
  heading?: string
  benefitsData?: BenefitItemProps[]
  tnc?: ReactNode
  faq?: ReactNode
  /** Banner image src (desktop). */
  desktopImages?: string
  imageHeight?: string | number
  /** Banner image src (mobile). */
  mobileImage?: string
  tncLink?: string
}

const IconContainer = styled.span`
  position: relative;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 1rem;
  z-index: 2;

  img {
    width: 100%;
    height: 100%;
    opacity: 1;
    transition: opacity 0.3s ease;
  }
`

const Benefits = ({
  heading = 'Benefits',
  benefitsData,
  tnc,
  faq,
  desktopImages,
  imageHeight,
  mobileImage,
  tncLink = '/tnc'
}: BenefitsProps) => {
  // const IconContainer = styled.span`
  //   position: relative;
  //   width: 24px;
  //   height: 24px;
  //   display: flex;
  //   align-items: center;
  //   justify-content: center;
  //   margin-right: 1rem;
  //   z-index: 2;

  //   img {
  //     width: 100%;
  //     height: 100%;
  //     opacity: ${(props) => (props.isActive ? 1 : 0.3)};
  //     transition: opacity 0.3s ease;
  //   }
  // `;

  const [activeItems, setActiveItems] = useState(
    Array.from({ length: benefitsData?.length ?? 0 }, () => false)
  )
  const { faqRef } = useStore()

  useEffect(() => {
    setActiveItems(Array.from({ length: benefitsData?.length ?? 0 }, () => false))
  }, [benefitsData])

  useEffect(() => {
    const handleScroll = () => {
      const elements = document.querySelectorAll('.benefit-item')
      const newActiveItems = [...activeItems]
      let hasChanged = false

      elements.forEach((element, index) => {
        const rect = element.getBoundingClientRect()
        const isVisible = rect.top <= window.innerHeight * 0.75
        if (newActiveItems[index] !== isVisible) {
          newActiveItems[index] = isVisible
          hasChanged = true
        }
      })

      if (hasChanged) {
        setActiveItems(newActiveItems)
      }
    }

    window.addEventListener('scroll', handleScroll)
    handleScroll()

    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <section id="benefits" className="about section about-section px-3 mx-sm-3">
      <div className="benefits container mx-auto" data-aos="fade-up">
        <Row>
          <div className="benefits-carousel d-lg-flex">
            <Col className="carousel-header pt-3 mx-lg-3" lg={6} xs={12}>
              <h2 className="benefits-heading">{heading}</h2>
              <Col lg={12} xs={12} className="gy-5 desktop" data-aos="fade-up" data-aos-delay="100">
                <Container>
                  {/* {desktopImages.map((row, rowIndex) => ( */}
                  <Row
                  // key={rowIndex}
                  // className={`align-items-${
                  //   rowIndex === 0
                  //     ? "end"
                  //     : rowIndex === 1
                  //     ? "center"
                  //     : "start"
                  // } justify-content-center my-1`}
                  >
                    {/* {row.map((image, index) => ( */}
                    <Col
                      // key={index}
                      // xl={
                      //   rowIndex === 0
                      //     ? index === 0
                      //       ? 3
                      //       : 4
                      //     : rowIndex === 1
                      //     ? index === 0
                      //       ? 8
                      //       : 4
                      //     : index === 0
                      //     ? 4
                      //     : 7
                      // }
                      className="banner-image-container"
                      // data-aos={`flip-${index % 2 === 0 ? "left" : "right"}`}
                      data-aos-delay="200"
                    >
                      <img
                        src={desktopImages}
                        // src={image} to be used in the next release
                        className="banner-image"
                        alt="Benefits Image"
                        style={{
                          // width: "100%",
                          height: imageHeight ?? '100%'
                          // objectFit: "contain", // or "contain" if you want full image visible
                        }}
                      />
                    </Col>
                    {/* ))} */}
                  </Row>
                  {/* ))} */}
                  {/* <Row>
                      <Col
                        xl={12}
                        className="g-5 table-desktop align-items-start"
                        data-aos-delay="200"
                      >
                        <Link className="link_benefits" href={tncLink}>
                          {tnc}{" "}
                        </Link>
                      </Col>
                    </Row> */}
                </Container>
              </Col>

              <Col
                lg={12}
                className="flex align-items-center mobile"
                data-aos="flip-up"
                data-aos-delay="200"
              >
                <img src={mobileImage} style={{ width: '100%' }} alt="" />
              </Col>
            </Col>
            <div className="my-4 w-lg-50">
              <Row className="justify-content-between gx-0">
                <Col
                  // lg={6}
                  xs={12}
                  className="gy-5"
                  data-aos="fade-up"
                  data-aos-delay="100"
                >
                  <div className="position-relative d-flex flex-1 flex-column gap-6 py-1 px-1 md:gap-10">
                    <div className="progress-wrap position-absolute left-0 w-9 overflow-hidden">
                      <div
                        className="progress-line position-absolute left-0 top-0 z-0  w-100"
                        style={{
                          transform: `scaleY(${
                            activeItems.filter(Boolean).length / activeItems.length
                          })`,
                          transformOrigin: 'top',
                          transition: 'transform 0.5s ease',
                          backgroundColor: '#221AFB'
                        }}
                      />
                    </div>

                    {benefitsData?.map((benefit, index) => (
                      <div className="benefit-item" key={index}>
                        <BenefitItem {...benefit} isActive={activeItems[index]} />
                      </div>
                    ))}
                  </div>

                  <Col
                    // md={12}
                    className="gy-5"
                    // data-aos-delay="200"
                    lg={12}
                    xs={12}
                    data-aos="fade-up"
                    data-aos-delay="100"
                  >
                    <div className="benefit-footer-container">
                      {faq && (
                        <div className="benefit-content-container">
                          <IconContainer>
                            <img src={qmark.src} alt="" />
                          </IconContainer>
                          <span
                            className="link_benefits"
                            onClick={() => {
                              if (faqRef.current) {
                                const offset = 400 // Adjust this value as needed
                                const topPosition =
                                  faqRef.current.getBoundingClientRect().top +
                                  window.pageYOffset -
                                  offset
                                window.scrollTo({
                                  top: topPosition,
                                  behavior: 'smooth'
                                })
                              }
                            }}
                          >
                            {faq}{' '}
                          </span>
                        </div>
                      )}
                      {faq && <span className="mx-3 vertical-line">|</span>}
                      {tnc && (
                        <div className="benefit-content-container">
                          <IconContainer>
                            <img src={terms.src} alt="" />
                          </IconContainer>
                          <Link className="link_benefits" href={tncLink}>
                            {tnc}{' '}
                          </Link>
                        </div>
                      )}
                    </div>
                  </Col>
                </Col>
              </Row>
            </div>
          </div>
        </Row>
      </div>
    </section>
  )
}

export default Benefits
